<template>
  <svg :width="size" :height="size" :viewBox="viewBox" :style="{ transform: 'rotate(-90deg)' }">
    <!-- 定义渐变 -->
    <defs>
      <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:#FAD961; stop-opacity:1" />
        <stop offset="100%" style="stop-color:#F76B1C; stop-opacity:1" />
      </linearGradient>
    </defs>
    <!-- 背景圆形 -->
    <circle
      :cx="center"
      :cy="center"
      :r="radius"
      stroke="#383E49"
      :stroke-width="strokeWidth"
      fill="none"
    />
    <!-- 使用渐变色的外圈 -->
    <circle
      :cx="center"
      :cy="center"
      :r="radius"
      stroke="url(#grad1)"
      :stroke-width="strokeWidth"
      fill="none"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="offset"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    // 调整大小
    size: {
      type: Number,
      default: 132, // 默认大小
    },
    // 调整边框粗细
    strokeWidth: {
      type: Number,
      default: 8, // 默认边框粗细
    },
    // 调整百分比
    percentage: {
      type: Number,
      default: 0, // 默认百分比
    },
  },
  computed: {
    // 计算圆的相关属性
    radius() {
      return (this.size - this.strokeWidth) / 2; // 半径
    },
    center() {
      return this.size / 2; // 圆心坐标
    },
    circumference() {
      // 计算周长
      return 2 * Math.PI * this.radius;
    },
    // offset() {
    //   // 计算偏移量
    //   return this.circumference * (1 - this.percentage / 100);
    // },
    viewBox() {
      return `0 0 ${this.size} ${this.size}`; // SVG viewBox
    },
  },
  data() {
    return {
      offset: 0
    };
  },
  created() {
    this.offset = this.circumference * (1 - 0 / 100)
  },
  mounted() {
    // 启动转动动画
    setTimeout(() => {
      this.updateOffset();
    }, 0.3 * 1000);
  },
  methods: {
    // 启动转动动画
    updateOffset() {
      // 慢慢增加偏移量
      let start = 0;
      const end = this.percentage;
      const step = () => {
        if (start <= end) {
          this.offset = this.circumference * (1 - start / 100);
          start += 1.5;
          requestAnimationFrame(step);
        }
      };
      // 启动动画
      requestAnimationFrame(step);
      // 结束时设置为最终值
      setTimeout(() => {
        this.offset = this.circumference * (1 - end / 100);
      }, end * 10); // 根据百分比调整延迟
    },
  },
};
</script>

<style scoped>
/* 你可以在这里添加更多的样式 */
</style>